// extracted by mini-css-extract-plugin
export default {"position":"CurrentWork_position__dDuDm","company":"CurrentWork_company__p6MuS","work":"CurrentWork_work__sN9hA","workMasked":"CurrentWork_workMasked__n2gAg"};